import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[gymfinderDropZone]',
  standalone: false,
})
export class DropZoneDirective {
  public constructor() {}

  @Output() fileDropped = new EventEmitter<FileList>();
  @HostBinding('class.hovered') hovered: boolean;

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.hovered = true;
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.hovered = false;
  }

  @HostListener('drop', ['$event']) public ondrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.hovered = false;

    if (event.dataTransfer?.files && event.dataTransfer.files.length) {
      this.fileDropped.emit(event.dataTransfer.files);
    }
  }
}
